import type ImageSize from "~/models/image/ImageSize";

const IMAGE_DIMENSIONS: ImageSize = {
  width: 160,
  height: 160,
};

export default IMAGE_DIMENSIONS;
